import React from 'react';
import { ImageIcon } from 'lucide-react';
interface ImagePlaceholderProps {
  label: string;
  aspect?: string;
  className?: string;
}
export function ImagePlaceholder({
  label,
  aspect = 'aspect-[16/9]',
  className = ''
}: ImagePlaceholderProps) {
  return <div role="img" aria-label={`Placeholder: ${label}`} className={`w-full ${aspect} rounded-md border-2 border-dashed border-stone-border bg-stone-light flex flex-col items-center justify-center gap-3 px-6 text-center ${className}`} data-id="element-33" data-mp="w2ihspl69jnb">
      <ImageIcon className="w-8 h-8 text-stone-medium" aria-hidden="true" data-id="element-34" data-mp="3untfes1imszz" />
      <p className="text-sm font-medium text-stone-medium" data-id="element-35" data-mp="d6iisuts1fu8">
        Placeholder — {label}
      </p>
    </div>;
}